var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcElementary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    width: 35.197,
    height: 38.052,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_elementary",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(336.235 220.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178-2",
    "data-name": "Group 178",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21728",
    "data-name": "Path 21728",
    d: "M16.418,33.195A15.874,15.874,0,1,1,32.293,17.319,15.892,15.892,0,0,1,16.418,33.195",
    transform: "translate(1.181 3.153)",
    fill: "#ffcc54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21729",
    "data-name": "Path 21729",
    d: "M2.685,19.464a15.863,15.863,0,0,1,25.892-12.3A15.866,15.866,0,1,0,6.259,29.481,15.791,15.791,0,0,1,2.685,19.464",
    transform: "translate(0.878 2.846)",
    fill: "#ffe8b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21730",
    "data-name": "Path 21730",
    d: "M6.316,6.938A2.491,2.491,0,0,1,8.805,9.427a.861.861,0,1,0,1.723,0,4.214,4.214,0,0,0-8.427,0,.863.863,0,0,0,1.726,0A2.491,2.491,0,0,1,6.316,6.938",
    transform: "translate(4.578 11.363)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21731",
    "data-name": "Path 21731",
    d: "M10.579,5.214A4.217,4.217,0,0,0,6.367,9.426a.861.861,0,1,0,1.723,0,2.489,2.489,0,1,1,4.978,0,.863.863,0,1,0,1.726,0,4.22,4.22,0,0,0-4.215-4.212",
    transform: "translate(13.873 11.361)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21732",
    "data-name": "Path 21732",
    d: "M17.6,2.855a17.614,17.614,0,0,0-4.352.563c-.718-1.151-1.392-2.1-1.656-2.457l-.7-.96-.7.96a35.047,35.047,0,0,0-3.366,5.6A17.571,17.571,0,1,0,17.6,2.855m-6.7.114c.321.474.655.989.979,1.516l.226.375c.184.305.347.585.493.846l.079.146c.124.223.235.432.337.626.025.051.051.1.073.153.1.2.191.385.267.553l.006.013A8.387,8.387,0,0,1,13.673,8c.019.06.041.121.057.178.025.083.045.159.06.226a2.1,2.1,0,0,1,.064.426,2.96,2.96,0,1,1-5.919,0,1.9,1.9,0,0,1,.057-.391,6.053,6.053,0,0,1,.34-1.008l.134-.312a32.117,32.117,0,0,1,2.429-4.155m6.7,33.36A15.894,15.894,0,0,1,1.723,20.453,15.71,15.71,0,0,1,6.243,9.381l.01.051a4.773,4.773,0,0,0,.168.795,5.051,5.051,0,0,0,.308.741l.029.06a4.631,4.631,0,0,0,.407.629c.022.029.041.057.064.083a4.661,4.661,0,0,0,.5.534c.029.025.057.054.089.079a4.589,4.589,0,0,0,.579.436l.1.06a4.548,4.548,0,0,0,.658.331l.1.035a4.461,4.461,0,0,0,.738.213l.073.013a4.668,4.668,0,0,0,5.509-4.606A3.384,3.384,0,0,0,15.5,8.2c-.013-.067-.025-.134-.045-.2-.054-.226-.124-.461-.21-.709-.025-.07-.057-.146-.086-.223a17.35,17.35,0,0,0-1-2.1A15.872,15.872,0,1,1,17.6,36.329",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21733",
    "data-name": "Path 21733",
    d: "M11.356,8.332A11.261,11.261,0,0,0,3.1,11.892a.862.862,0,1,0,1.252,1.186,9.623,9.623,0,0,1,14.006,0,.862.862,0,1,0,1.253-1.186,11.261,11.261,0,0,0-8.256-3.56",
    transform: "translate(6.242 18.155)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21734",
    "data-name": "Path 21734",
    d: "M5.456.934c.321.474.655.989.979,1.516l.226.375c.184.305.347.582.493.846l.079.143c.124.226.235.436.337.629l.076.153c.1.2.188.385.264.553l.006.013a8.075,8.075,0,0,1,.318.807c.019.06.041.121.057.178.025.083.045.159.06.226a2.1,2.1,0,0,1,.064.426A2.96,2.96,0,1,1,2.5,6.8a2.15,2.15,0,0,1,.057-.391A5.844,5.844,0,0,1,2.9,5.4l.13-.315A32.3,32.3,0,0,1,5.456.934",
    transform: "translate(5.439 2.035)",
    fill: "#57b6dd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcElementary);
export default __webpack_public_path__ + "static/media/ic_elementary.72e8b8ca1c12b54ed5b92cd3c51a4091.svg";
export { ForwardRef as ReactComponent };